<template>
  <!-- 订单汇总 -->
  <div class="orderSummary">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refersh')"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">支付类型：</label>
        <el-select
          v-model="searchForm.payType"
          placeholder="支付类型"
          style="width: 100px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in payType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          class="search-item-input"
          v-model="searchForm.startDate"
          placeholder="起始日期"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          class="search-item-input"
          v-model="searchForm.endDate"
          placeholder="截止日期"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-input
          class="search-item-input"
          v-model="searchForm.searchVal"
          clearable
          placeholder="订单编号/客户名称"
        >
        </el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          icon="el-icon-search"
          @click="getTableData('search')"
          >搜索
        </el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        prop="OrderNo"
        align="center"
        show-overflow-tooltip
        label="订单编号"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="BusinessCode"
        show-overflow-tooltip
        label="客户ERP编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="BusinessName"
        show-overflow-tooltip
        label="单位名称"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="PayType"
        show-overflow-tooltip
        label="支付方式"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="RealAmount"
        show-overflow-tooltip
        label="订单金额"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="PaymentFee"
        show-overflow-tooltip
        label="支付金额"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="RefundFee"
        show-overflow-tooltip
        label="退款金额"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="OrderStatus"
        show-overflow-tooltip
        label="状态"
      >
      </el-table-column>
      <el-table-column
        prop="PayTime"
        label="支付时间"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="Thirdparty"
        label="交易单号"
        align="center"
        show-overflow-tooltip
        width="250"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//混入
export default {
  name: "orderSummary",
  data() {
    return {
      /**用户信息 */
      entId: "",
      userId: "",

      /**搜索 */
      searchForm: {
        payType: "",
        searchVal: "",
        startDate: "2023-01-01",
        endDate: "",
      },

      payType: [], //支付方式列表

      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },

  mounted() {
    this.userId = window.localStorage.getItem("userId");
    this.entId = window.localStorage.getItem("entId");
    this.getTableData("refresh");
    this.getPayType();
  },
  methods: {
    /**获取表格数据 */
    getPayType() {
      let data = {
        entId: localStorage.getItem("entId"),
      };
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.payType = res.list.map((item) => ({
            value: item.PayId,
            label: item.PayType,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    /**获取表格 */
    getTableData(type = "") {
      if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.payType = "";
        this.searchForm.searchVal = "";
        this.searchForm.startDate = this.$theMonthFirstDay(); //默认本月一号开始查询
        this.searchForm.endDate = "";
      } else if (type == "search") {
        this.currPage = 1;
      }

      this.$request({
        url: "/Management/OrderAdmin/OrderMtAnalysisApi",
        method: "post",
        data: {
          endDate: this.searchForm.endDate,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
          payType: this.searchForm.payType,
          searchVal: this.searchForm.searchVal,
          startDate: this.searchForm.startDate,
        },
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dateList;
            this.allPage = res.toTal;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    // 导出数据
    exportData() {
      window.location.href =
        this.baseUrl +
        "/Management/OrderAdmin/ToExcelOrderMtAnalysisApi?startDate=" +
        this.searchForm.startDate +
        "&endDate=" +
        this.searchForm.endDate +
        "&searchVal=" +
        this.searchForm.searchVal +
        "&payType=" +
        this.searchForm.payType;
    },
  },
};
</script>

<style scoped>
.orderSummary {
  width: 100%;
  height: 100%;
}

/**搜索输入框 */
.search-item-input {
  width: 150px;
  margin-left: 5px;
}

/**自定义表格内容，图片上下居中问题 */
.table-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

/**消息回复 */
.msg {
}

.msg-tit {
  font-size: 16px;
}

.msg-item {
  margin-top: 10px;
  text-indent: 30px;
}

.msg-send {
  height: 150px;
  padding: 10px 0;
  box-sizing: border-box;
}

.msg-send-btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
